import { render, staticRenderFns } from "./rukuzhanghu.vue?vue&type=template&id=58402cec"
import script from "./rukuzhanghu.vue?vue&type=script&lang=js"
export * from "./rukuzhanghu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports